import { render } from "./StockRecipeSales.vue?vue&type=template&id=b7bf249a&scoped=true"
import script from "./StockRecipeSales.vue?vue&type=script&lang=js"
export * from "./StockRecipeSales.vue?vue&type=script&lang=js"

import "./StockRecipeSales.vue?vue&type=style&index=0&id=b7bf249a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7bf249a"]])

export default __exports__